import { alertModalTranslationEN } from 'components/common/AlertModal/translation/locales';
import { confirmModalTranslationEN } from 'components/common/ConfirmModal/translation/locales';
import { errorDataDetailModalTranslationEN } from 'components/common/ErrorDataDetailModal/translation/locales';
import { errorDataSummaryModalTranslationEN } from 'components/common/ErrorDataSummaryModal/translation/locales';
import { imageUploadModalTranslationEN } from 'components/common/ImageUploadModal/translation/locales';
import { reArrangeMenuModalTranslationEN } from 'components/common/ReArrangeMenuModal/translation/locales';
import { statusHeaderTranslationEN } from 'components/common/StatusHeader/translation/locales';
import { selectDepartmentModalTranslationEN } from 'components/SelectDepartmentModal/locales';
import { selectSingleRestaurantModalTranslationEN } from 'components/SelectSingleRestaurantModal/locales';
import { TargetMenuModalTranslationEN } from 'components/TargetMenuModal/translation/locales';
import { authFeatureTranslationEN } from 'features/Auth/translation/locales';
import { BarListTranslationEN } from 'features/BarGuideInfo/translation/locales';
import { BarMenuTranslationEN } from 'features/BarGuideInfoMenu/translation/locales';
import { deliveryFeatureTranslationEN } from 'features/Delivery/translation/locales';
import { displayTimingGroupTranslationEN } from 'features/DisplayTimingGroup/translation/locales';
import { eatingWayFeatureTranslationEN } from 'features/EatingWay/translation/locales';
import { importDataTranslationEN } from 'features/ImportData/translation/locales';
import { mainMenuFeatureTranslationEN } from 'features/MainMenu/translation/locales';
import { menuBookFeatureTranslationEN } from 'features/MenuBook/translation/locales';
import { menuDetailFeatureTranslationEN } from 'features/MenuDetail/translation/locales';
import { OverlayFunctionTranslationEN } from 'features/OverlayFunction/translation/locales';
import { saleTypeFeatureTranslationEN } from 'features/SaleType/translation/locales';
import { storeFeatureTranslationEN } from 'features/Store/translation/locales';
import { subMenuListFeatureTranslationEN } from 'features/SubMenuList/translation/locales';
import { SubTitleMenuTranslationEN } from 'features/SubTitleMenu/translation/locales';

const commonTranslationEN = {
  App: {
    app_name: process.env.REACT_APP_APP_NAME,
    error: 'Error',
    info: 'Info',
    warning: 'Warning',
    confirm: 'Confirmation',
    loading: 'Loading...',
    change: 'Change',
    success: 'Success',
    unexpected_error: 'Unexpected Error',
  },
  ...statusHeaderTranslationEN,
  ...confirmModalTranslationEN,
  ...alertModalTranslationEN,
  ...selectDepartmentModalTranslationEN,
  ...selectSingleRestaurantModalTranslationEN,
  ...imageUploadModalTranslationEN,
  ...errorDataSummaryModalTranslationEN,
  ...errorDataDetailModalTranslationEN,
  ...reArrangeMenuModalTranslationEN,
};

export const translationEN = {
  ...commonTranslationEN,
  ...authFeatureTranslationEN,
  ...mainMenuFeatureTranslationEN,
  ...deliveryFeatureTranslationEN,
  ...storeFeatureTranslationEN,
  ...subMenuListFeatureTranslationEN,
  ...saleTypeFeatureTranslationEN,
  ...menuBookFeatureTranslationEN,
  ...importDataTranslationEN,
  ...menuDetailFeatureTranslationEN,
  ...BarListTranslationEN,
  ...SubTitleMenuTranslationEN,
  ...eatingWayFeatureTranslationEN,
  ...BarMenuTranslationEN,
  ...OverlayFunctionTranslationEN,
  ...TargetMenuModalTranslationEN,
  ...displayTimingGroupTranslationEN,
};
